<template>
  <div class="main-layout">
    <!-- 头部组件 -->
    <AppHeader :navArr="navArr" :index="currentIndex" />

    <!-- 主内容区域 -->
    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/Header.vue'

export default {
  name: "MainLayout",
  components: {
    AppHeader,
  },
  data() {
    return {
      navArr: [],
      currentIndex: 0
    };
  },
  methods: {
    handleMainMenuChange(menuItem) {
      console.log('主菜单切换:', menuItem);
      // 处理主菜单切换逻辑
    },

    handleSubMenuChange(subMenuItem) {
      console.log('子菜单切换:', subMenuItem);
      // 处理子菜单切换逻辑
    }
  }
};
</script>

<style lang="scss" scoped>
.main-layout {
  min-height: 100vh;
  // background: #F5F5F5;
  background: url("@/assets/images/public/index.png") no-repeat;
  background-size: cover;
}

.main-content {
  height: calc(100vh - 170px);
  overflow-y: auto;
}
</style>
